import { Flex, Progress } from '@chakra-ui/react';
import React from 'react';

import { COLOR_SCHEMES } from 'packages/common-frontend/theme';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';

// Constants
const COMPONENT_NAME = './chakra/Progress';

// Fragments
const RouteBase = () => (
  <PageTemplate title={COMPONENT_NAME}>
    <ComponentGridRenderer
      primaries={COLOR_SCHEMES}
      primaryPropName="colorScheme"
      secondaries={['sm', 'md', 'lg']}
      secondaryPropName="size"
      tertiaries={[null]}
      width="30vw"
    >
      {({ primary: colorScheme, secondary: size }) => (
        <Flex direction="column" flexGrow={0} width="100%" gap="0.5rem">
          <Progress colorScheme={colorScheme} size={size} value={0} />
          <Progress colorScheme={colorScheme} size={size} value={50} />
          <Progress colorScheme={colorScheme} size={size} value={100} />
        </Flex>
      )}
    </ComponentGridRenderer>
  </PageTemplate>
);

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
